import * as types from './mutation-types';

export default {
  [types.SET_SAT_IDENTIFICATION_COLLECTION](state, payload) {
    state.satIdentificationCollection = payload;
  },
};
